module.exports = __webpack_public_path__ + "img/alxq3.4297f50a.png";